// 路由守卫 Routing guard
import ajax from '@common/utils/ajax'
import {getLoginUser} from '@common/utils'
import {getCookie, jsonParseSafe} from "../../common/utils";
import {isShengzheng, projectId_} from "../constants";


function sz_webtrack() {
  window.eps = [];
  window.eps.push(['siteId', '5nqxc0ucby']);
  (function () {
    var spot = document.createElement('script');
    spot.type = 'text/javascript';
    spot.async = true;
    spot.id = "coolgua_src";
    var domain = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'webtrack.coolgua.net';
    spot.src = domain + '/js/track.js?domain=' + domain + '&siteId=5nqxc0ucby';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(spot, s);
  })();


  var _hmt = _hmt || [];
  (function () {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?9a22fb11fc273fc0b86851f9914142f5";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();

  //谷歌
  (function () {
    var hm = document.createElement("script");
    hm.src = "https://www.googletagmanager.com/gtag/js?id=UA-2339291-40";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);

    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
  
    gtag('config', 'UA-2339291-40');
  })();

}

function sh_webtrack() {
  window.eps = [];
  window.eps.push(['siteId', '5uns856er8']);
  (function () {
    var spot = document.createElement('script');
    spot.type = 'text/javascript';
    spot.async = true;
    spot.id = "coolgua_src";
    var domain = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'webtrack.coolgua.net';
    spot.src = domain + '/js/track.js?domain=' + domain + '&siteId=5uns856er8';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(spot, s);
  })();


  var _hmt = _hmt || [];
  (function () {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?8eea79e3b5e61c8b57d453160bb5d9c4";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();

    //谷歌
    (function () {
      var hm = document.createElement("script");
      hm.src = "https://www.googletagmanager.com/gtag/js?id=UA-2339291-39";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
  
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
    
      gtag('config', 'UA-2339291-39');
    })();
}

export default (router) => {
  router.beforeEach((to, from, next) => {
    console.log('去到页面', to,from)
    let projectId = to.query && to.query.projectId || getLoginUser() && getLoginUser().projectId || sessionStorage.getItem('projectId') || projectId_
    //不需要登陆 白名单
    if (to.path.indexOf('purchaser/register') >= 0 ) {
      next()
      return false
    }
    if (to.path.indexOf('/login') >= 0 ) {
      sessionStorage.setItem("projectId",to.query.projectId|| projectId_)
      next()
      return false
    }
    if (projectId) {
      ajax.get(`/api3/backend/v1/statistics/addPVUV/` + projectId)
    }
    // if(to.path.indexOf('exhibition')) {
    //   var user = jsonParseSafe(getCookie('user2'))
    //   //没有登陆用户跳转到【登陆界面】
    //   if (!user || !user.id) {
    //     //    跳转到首页
    //     next({path: `/login?projectId=${projectId}`});
    //     sessionStorage.setItem('toDetail', to.path)
    //     return false
    //   }
    // }
    // if (to.path != '/login') {
    //   var user = jsonParseSafe(getCookie('user2'))
    //   //没有登陆用户跳转到【登陆界面】
    //   if (!user || !user.id) {
    //     //    跳转到首页
    //     next({path: `/login?projectId=${projectId}`})
    //     return false
    //   }
    // }
    if (to.path == '/me/purchaser/requirement/add') {
      var user = jsonParseSafe(getCookie('user2'))
        //没有登陆用户跳转到【登陆界面】
        if (!user || !user.id) {
          //    跳转到首页
          next({path: `/login?projectId=${projectId}`})
          return false
        }
    }

    next() // 若点击的是不需要验证的页面,则进行正常的路由跳转
  });
  //来源追踪 web track
  router.afterEach((to, from, next) => {
    if (isShengzheng) {
      //sz_webtrack()
    } else {
      //sh_webtrack()
    }
  });

}




// WEBPACK FOOTER //
// ./src/wenxing/router/routerGuard.js